
const testimonials = [
  {
    name: 'Sarah Johnson',
    role: 'CEO, TechStart Inc',
    rating: 5,
    text: 'Abdul Raheem transformed our brand identity into something extraordinary – highly recommended! His attention to detail and creative vision exceeded all expectations.',
    avatar: 'https://public.readdy.ai/ai/img_res/868d6449e2a5f23722f53b32ee20beba.jpg',
  },
  {
    name: 'Michael Chen',
    role: 'Marketing Director',
    rating: 5,
    text: 'Professional, creative, extremely talented. Our social media visuals never looked better. The engagement rates have skyrocketed since we started working with him.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20portrait%20photo%20with%20simple%20clean%20background%20friendly%20expression%20wearing%20casual%20business%20attire%20high%20quality%20headshot%20photography%20with%20soft%20lighting&width=200&height=200&seq=client-002&orientation=squarish',
  },
  {
    name: 'Emily Rodriguez',
    role: 'Founder, Creative Studio',
    rating: 5,
    text: 'Top-notch design services with premium touch. Very satisfied! Abdul brings a level of sophistication and elegance to every project he touches.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20creative%20woman%20portrait%20photo%20with%20simple%20background%20warm%20smile%20wearing%20stylish%20casual%20attire%20high%20quality%20photography%20with%20natural%20lighting%20and%20soft%20colors&width=200&height=200&seq=client-003&orientation=squarish',
  },
  {
    name: 'David Thompson',
    role: 'Business Owner',
    rating: 5,
    text: 'Exceptional creativity and attention to detail. Our brand looks amazing! Working with Abdul was a game-changer for our business identity.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20entrepreneur%20portrait%20photo%20with%20clean%20simple%20background%20confident%20professional%20look%20wearing%20business%20casual%20attire%20high%20quality%20headshot%20with%20soft%20lighting&width=200&height=200&seq=client-004&orientation=squarish',
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 font-['Montserrat']">
            Client <span className="text-[#fcd34d]">Testimonials</span>
          </h2>
          <p className="text-white/60 text-lg font-['Roboto'] max-w-2xl mx-auto mb-6">
            Hear what my clients say about working with me
          </p>
          <div className="flex items-center justify-center gap-2 mb-2">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="ri-star-fill text-3xl text-[#fcd34d]"></i>
            ))}
          </div>
          <p className="text-[#fcd34d] text-xl font-bold font-['Montserrat']">
            100% Client Satisfaction Rate
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="group relative bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10 hover:border-[#fcd34d]/50 shadow-xl hover:shadow-2xl hover:shadow-[#fcd34d]/20 transition-all duration-500 hover:scale-105 cursor-pointer"
            >
              <div className="absolute top-6 right-6 text-6xl text-[#fcd34d]/10 font-['Montserrat']">
                "
              </div>

              <div className="flex items-center gap-4 mb-6">
                <div className="relative w-16 h-16">
                  <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#fcd34d] to-[#facc15] blur-md opacity-50"></div>
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="relative w-full h-full rounded-full object-cover border-2 border-white/20"
                  />
                </div>
                <div>
                  <h4 className="text-lg font-bold text-white font-['Montserrat']">
                    {testimonial.name}
                  </h4>
                  <p className="text-white/60 text-sm font-['Roboto']">
                    {testimonial.role}
                  </p>
                </div>
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xl text-[#fcd34d]"></i>
                ))}
              </div>

              <p className="text-white/80 font-['Roboto'] leading-relaxed">
                {testimonial.text}
              </p>

              <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-tl from-[#fcd34d]/5 to-transparent rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
